import { Form } from 'ui/components/3-organisms/Form/Form';
import { useEffect, useRef } from 'react';
import { embedHelper, canLoadScript } from './formEmbed';

import { FormFeatureProps } from './formFeature';

export const ActiveCampaignFeature: React.FC<FormFeatureProps> = ({ content, kicker, selectAllLabel, placeholderLabel }) => {
	const scriptRef = useRef<HTMLDivElement | null>(null);

	const { isEmbedScript, formHtmlCode, sanitizedFormHtmlCode } = embedHelper(content?.properties?.formHtmlCode);
	useEffect(() => {
		if (isEmbedScript) {
			if (canLoadScript(scriptRef, formHtmlCode)) {
				loadActiveCampaignScript(scriptRef, formHtmlCode);
			}
		}
	}, [formHtmlCode, scriptRef, isEmbedScript]);
	return (
		<>
			<Form
				{...content.properties}
				kicker={kicker}
				bgColor={content?.properties.color}
				showImage={content.properties.showImage}
				layoutType={content.properties.layoutType}
				displayButtonRight={content?.properties?.displayButtonRight}
				selectAllLabel={selectAllLabel}
				inputFullWidth={content?.properties?.inputFullWidth}
				placeholderLabel={placeholderLabel}
				{...(isEmbedScript && {
					formHtmlCode: sanitizedFormHtmlCode,
				})}
			/>
			{isEmbedScript && <div ref={scriptRef} />}
		</>
	);
};

// ActiveCampaign forms.
const loadActiveCampaignScript = (scriptRef, formHtmlCode) => {
	const form = document.createRange().createContextualFragment(formHtmlCode);
	// To insert only the script, parse out other elements
	form.querySelectorAll('div').forEach((div) => div.remove());
	form.querySelectorAll('form').forEach((formElement) => {
		formElement.remove();
	});
	const scripts = form.querySelectorAll('script');
	const firstScript = scripts[0];
	if (firstScript) {
		firstScript.addEventListener('load', () => {
			const formElement = document.querySelector('.activecampaign') as HTMLDivElement | null;
			if (formElement) {
				const styleElement = formElement.querySelector('style');
				if (styleElement) {
					styleElement.remove();
				}
			}
		});
	}

	scriptRef?.current?.appendChild(form);
};
